const STRIDE = 1

const getRandPixel = () => {
  return Math.round(Math.random()) * 2 - 1
}

export const wild = (position) => {
  const nextPosition = {
    ...position,
    x: position.x + getRandPixel(),
    y: position.y + getRandPixel()
  }
  return nextPosition
}

export const moveLeft = (position, stride = STRIDE) => {
  return { ...position, x: position.x - stride, direction: ['left'] }
}

export const moveRight = (position, stride = STRIDE) => {
  return { ...position, x: position.x + stride, direction: ['right'] }
}

export const moveUp = (position, stride = STRIDE) => {
  return { ...position, y: position.y - stride, direction: ['up'] }
}

export const moveDown = (position, stride = STRIDE) => {
  return { ...position, y: position.y + stride, direction: ['down'] }
}

export const moveUpRight = (position, stride = STRIDE) => {
  return { ...position, x: position.x + stride, y: position.y - stride, direction: ['up', 'right'] }
}

export const moveDownRight = (position, stride = STRIDE) => {
  return { ...position, x: position.x + stride, y: position.y + stride, direction: ['down', 'right'] }
}

export const moveUpLeft = (position, stride = STRIDE) => {
  return { ...position, x: position.x - stride, y: position.y - stride, direction: ['up', 'left'] }
}

export const moveDownLeft = (position, stride = STRIDE) => {
  return { ...position, x: position.x - stride, y: position.y + stride, direction: ['down', 'left'] }
}

export const pause = (position) => {
  return position
}

export const moveToTarget = (x, y, position, stride = STRIDE) => {
  const nextPosition = { ...position, direction: [] }

  if (position.x < x) {
    let move = position.x + stride
    if (move > x) move = x
    nextPosition.x = move
    nextPosition.direction.push('right')
  } else if (position.x > x) {
    let move = position.x - stride
    if (move < x) move = x
    nextPosition.x = move
    nextPosition.direction.push('left')
  }

  if (position.y < y) {
    let move = position.y + stride
    if (move > y) move = y
    nextPosition.y = move
    nextPosition.direction.push('down')
  } else if (position.y > y) {
    let move = position.y - stride
    if (move < y) move = y
    nextPosition.y = move
    nextPosition.direction.push('up')
  }

  return nextPosition
}

// Slide-fallback used by NPCs/monsters: tries direct, then x-only, then y-only.
// Returns true if any move succeeded. `update(x, y)` is called on success.
export const tryMoveTo = (tx, ty, pos, stride, isColliding, update) => {
  const direct = moveToTarget(tx, ty, pos, stride)
  if (!isColliding(direct)) { update(direct.x, direct.y); return true }
  if (direct.x !== pos.x) {
    const xOnly = { ...pos, x: direct.x }
    if (!isColliding(xOnly)) { update(xOnly.x, xOnly.y); return true }
  }
  if (direct.y !== pos.y) {
    const yOnly = { ...pos, y: direct.y }
    if (!isColliding(yOnly)) { update(yOnly.x, yOnly.y); return true }
  }
  return false
}

// Perpendicular snap used by the player: nudges along the cross-axis to slip through gaps.
// Returns a snapped position or null if no gap found within threshold pixels.
export const snapToGap = (nextPos, isColliding, threshold) => {
  const dir = nextPos.direction
  const horizontal = Array.isArray(dir)
    ? dir.some(d => d === 'left' || d === 'right')
    : (dir === 'left' || dir === 'right')
  const axis = horizontal ? 'y' : 'x'
  for (let d = 1; d <= threshold; d++) {
    const a = { ...nextPos, [axis]: nextPos[axis] - d }
    if (!isColliding(a)) return a
    const b = { ...nextPos, [axis]: nextPos[axis] + d }
    if (!isColliding(b)) return b
  }
  return null
}

export default {
  moveToTarget,
  moveDownLeft,
  moveUpLeft,
  moveLeft,
  moveDownRight,
  moveUpRight,
  moveRight,
  moveUp,
  moveDown,
  pause
}
